import React, { Component } from 'react';
import { withStyles } from '@material-ui/core/styles';
import CalendarHelper from '../classes/CalendarHelper.js';
import Chart from "react-apexcharts";
import i18n from 'i18next';

const useStyles = theme => ({});

/**
 * Chart Project User Detail
 */
class ChartProjectUserDetail extends Component {
    state = {
        chart: ""
    }

    /// Get x-axis labels
    getLabels( projectReport ) {
        let labels = [];

        const monthNames = CalendarHelper.getMonthNames( this.props.language, "short" );

        if( null != projectReport ) {
            for( let i = 0; i < projectReport.resultProject.years.length; i++ ) {

                const yearString = " '" + projectReport.resultProject.years[i].year.toString().substring( 2, 4 )
                for( let j = 0; j < projectReport.resultProject.years[i].months.length; j++ ) {

                    // Add label for the month
                    labels.push( monthNames[projectReport.resultProject.years[i].months[j].month-1] + yearString );
                }
            }
        }

        return labels;
    }

    /// Get series: accounted hours in month
    getSeriesAccountedHours( projectReport ) {
        let chartSeries = [];

        if( null != projectReport ) {

            let series = {
                name: i18n.t("pages.reports.options.project.chart_userdetail.series.sum_in_month.name"),
                id: 0,
                type: 'line',
                data: []
            }
            chartSeries.push( series );

            // Add an empty series per task of the selected user
            for( let i = 0; i < projectReport.resultUsers.length; i++ ) {
                if( projectReport.resultUsers[i].userid === this.props.userid ) {

                    // Sort by task name
                    projectReport.resultUsers[i].tasks.sort(function(a, b) { 
                        if( a.name > b.name ) return 1;
                        if( a.name < b.name ) return -1;
                        return 0;
                    });

                    // Only add the task series if the user has accounted hours on it
                    for( let j = 0; j < projectReport.resultUsers[i].tasks.length; j++ ) {
                        if( 0 < projectReport.resultUsers[i].tasks[j].hours_accounted_total ) {
                            let series = {
                                name: projectReport.resultUsers[i].tasks[j].name,
                                id: projectReport.resultUsers[i].tasks[j].taskid,
                                type: 'column',
                                data: []
                            }
                            chartSeries.push( series );
                        }
                    }
                }
            }

            const thisYear = new Date().getFullYear();
            const thisMonth = new Date().getMonth();

            // Handle the general summary of accounted hours series on that specific user
            for( let i = 0; i < projectReport.resultUsers.length; i++ ) {
                if( projectReport.resultUsers[i].userid === this.props.userid ) {
                    
                    for( let j = 0; j < projectReport.resultUsers[i].years.length; j++ ) {
                        for( let k = 0; k < projectReport.resultUsers[i].years[j].months.length; k++ ) {
                            let accountedHours = projectReport.resultUsers[i].years[j].months[k].hours_accounted_in_month;

                            // Only add if the current year and month is not past today's year and the past month
                            // in that case only add an empty string, else that looks awkward into the future
                            if( thisYear > projectReport.resultUsers[i].years[j].year || ( thisYear === projectReport.resultUsers[i].years[j].year && thisMonth >= j )) {
                                chartSeries[0].data.push( accountedHours );
                            } else {
                                chartSeries[0].data.push( 0 );
                            }
                        }
                    }
                }
            }

            // Fill the series for each task of the selected user
            for( let i = 0; i < projectReport.resultUsers.length; i++ ) {
                if( projectReport.resultUsers[i].userid === this.props.userid ) {

                    // Sort by task name
                    projectReport.resultUsers[i].tasks.sort(function(a, b) { 
                        if( a.name > b.name ) return 1;
                        if( a.name < b.name ) return -1;
                        return 0;
                    });

                    for( let j = 0; j < projectReport.resultUsers[i].tasks.length; j++ ) {

                        // The task to handle
                        let taskId = projectReport.resultUsers[i].tasks[j].taskid;

                        if( 0 < projectReport.resultUsers[i].tasks[j].hours_accounted_total ) {

                            // Now go through the years and months of the task of that user to fill the series
                            for( let k = 0; k < projectReport.resultUsers[i].years.length; k++ ) {
                                for( let l = 0; l < projectReport.resultUsers[i].years[k].months.length; l++ ) {
                                    for( let m = 0; m < projectReport.resultUsers[i].years[k].months[l].tasks.length; m++ ) {
                                        if( taskId === projectReport.resultUsers[i].years[k].months[l].tasks[m].taskid ) {
                                            let accountedHours = 0;

                                            // Only add if the current year and month is not past today's year and the past month
                                            // in that case only add an empty string, else that looks awkward into the future
                                            if( thisYear > projectReport.resultUsers[i].years[k].year || ( thisYear === projectReport.resultUsers[i].years[k].year && thisMonth >= j )) {
                                                accountedHours = projectReport.resultUsers[i].years[k].months[l].tasks[m].hours_accounted_in_month;
                                            }

                                            // Enter the accounted hours into the proper series for this user
                                            for( let seriesIndex = 1; seriesIndex < chartSeries.length; seriesIndex++ ) {
                                                if( taskId === chartSeries[seriesIndex].id ) {
                                                    chartSeries[seriesIndex].data.push( accountedHours );
                                                    break;
                                                }
                                            }
                                        }
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }

        return chartSeries;
    }

    /// Generate the year start annotations
    getYearAnnotations( projectReport ) {
        let annotations = [];

        const monthNames = CalendarHelper.getMonthNames( this.props.language, "short" );

        if( null != projectReport ) {
            for( let i = 0; i < projectReport.resultProject.years.length; i++ ) {
                const year = projectReport.resultProject.years[i].year;
                const yearCut = year.toString().substring(2, 4);
                const januaryLabel = monthNames[0] + " '" + yearCut;

                annotations.push(
                    {
                        x: januaryLabel,
                        borderColor: '#FF4560',
                        label: {
                            style: {
                                color: '#000',
                            },
                            orientation: 'vertical',
                            text: year.toString()
                        }
                    }
                )
            }
        }

        return annotations;
    }

    // Called by react when this component has been mounted
    componentDidMount() {

        // Pre-render chart since it will not change
        if( null !== this.props.projectReport && null !== this.props.dateMin && null !== this.props.dateMax && null !== this.props.userid ) {
            let accountingChart = this.renderAccountingChart( this.props.projectReport );
            this.setState({ chart: accountingChart });
        }
    }

    // Called by react when this component did update
    componentDidUpdate( prevProps ) {

        if( this.props.dateMin !== prevProps.dateMin || this.props.dateMax !== prevProps.dateMax || this.props.userid !== prevProps.userid ) {
            // Pre-render chart since it will not change
            if( null !== this.props.projectReport && null !== this.props.dateMin && null !== this.props.dateMax && null !== this.props.userid ) {
                let accountingChart = this.renderAccountingChart( this.props.projectReport );
                this.setState({ chart: accountingChart });
            }
        }
    }

    // Render
    renderAccountingChart( projectReport ) {

        const chartLabels = this.getLabels( projectReport );
        let chartSeries = this.getSeriesAccountedHours( projectReport );
        const yearAnnotations = this.getYearAnnotations( projectReport );

        const chartOptions = {
            chart: {
                animations: {
                    enabled: false
                },
                type: 'line',
                id: 'absence-chart',
                toolbar: {
                    tools: {
                        download: false,
                        pan: false
                    }
                }
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    columnWidth: '55%',
                    endingShape: 'rounded'
                }
            },
            annotations: {
                yaxis: [],
                xaxis: yearAnnotations,
                points: []
            },
            dataLabels: {
                enabled: false
            },
            stroke: {
                show: 'true',
                width: 2,
            },
            grid: {},
            title: {},
            labels: chartLabels,
            xaxis: {},
            yaxis: {
                min: 0,
                axisBorder: {
                    show: true,
                    offsetX: 0,
                    offsetY: 0
                },
                title: {
                    text: "NEW",
                    rotate: -90,
                    style: {
                        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
                        fontSize: '12px',
                        fontWeight: 100
                    }
                }
            },
            tooltip: {
                shared: true
            }
        }

        return (
            <Chart
                options={chartOptions}
                series={chartSeries}
                type="line"
            />
        )
    }

    render() {
        return (
            <div>
                {this.state.chart}
            </div>
        );
    }
};

export default withStyles(useStyles)(ChartProjectUserDetail);